import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    loggedUser: null,
    mePromise: null,
  }),
  actions: {
    setUser(data) {
      this.loggedUser = data;
    },
    resetUser() {
      this.loggedUser = null;
    },
    setAvatar(data) {
      if (this.loggedUser) {
        this.loggedUser.avatar = data;
      }
    },
    async login(data, opts = {}) {
      const { $api } = useNuxtApp();
      const response = await $api.post('auth/login', data, opts);

      this.loggedUser = response.data.user;
      const token = response.data.token;

      // Set auth token in cookie
      const cookieOptions = { path: '/' };
      if (data.remindMe) {
        cookieOptions.maxAge = 60 * 60 * 24 * 365; // 1 year
      }

      const authCookie = useCookie('Authorization', cookieOptions);
      authCookie.value = token;

      return response;
    },
    async logout() {
      const authCookie = useCookie('Authorization');
      authCookie.value = null;
      this.loggedUser = null;
    },
    async me() {
      const { $api } = useNuxtApp();
      const authCookie = useCookie('Authorization');
      if (!authCookie.value) return;

      if (this.mePromise) return this.mePromise;

      this.mePromise = (async () => {
        try {
          const response = await $api.get('users/me');
          this.loggedUser = response.data;
          return response;
        } catch (error) {
          // If error (e.g. 401), the plugin handles logout/redirect usually.
          // But we can clear state here too.
          this.loggedUser = null;
          return error;
        } finally {
          this.mePromise = null;
        }
      })();

      return this.mePromise;
    },
    async activate(data) {
      const { $api } = useNuxtApp();
      return await $api.post('auth/verify-email', data);
    },
    async unsubscribe(data) {
      const { $api } = useNuxtApp();
      return await $api.post('auth/unsubscribe', data);
    },
    async updateAvatar(data) {
      const { $api } = useNuxtApp();
      const response = await $api.post('auth/avatar', data);
      this.setAvatar(response.data.image);
      return response;
    },
    async requestDelAccount(data) {
      const { $api } = useNuxtApp();
      return await $api.delete('users', { body: data }); // Delete with body supported by ofetch? Yes.
    },
    async deleteAccount(data) {
      const { $api } = useNuxtApp();
      return await $api.delete('users', { body: data });
    },
    reset() {
      this.loggedUser = null;
      const authCookie = useCookie('Authorization');
      authCookie.value = null;
    },
  },
});
